/* eslint-disable react/prop-types */
import { Box, Grid, Typography } from "@mui/material";
import FormField from "components/FormField";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Form, Formik } from "formik";
import React from "react";
import TaxPersonalTable from "./components/table";
import initialValues from "./schema/initialValues";
import validation from "./schema/validations";
import form from "./schema/form";
import SoftButton from "components/SoftButton";
import SoftBox from "components/SoftBox";
import Loading from "components/Common/Loading";
import DatepickerField from "components/DatepickerField";
import SwitchField from "components/SwitchField";
import ModalCommon from "components/Modal";
import ModalContent from "./components/modalContent";
import Tabs from "./components/tabs";
import Actions from "./components/actions";

export default function CorporateIncomeTax02() {
  const [open, setOpen] = React.useState(true);
  const [tab, setTab] = React.useState(0);
  const { formId, formField } = form;

  const handleSubmit = async (values, action) => {
    console.log({ values });
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {!open && (
        <>
          <Tabs tab={tab} setTab={setTab} />
          <Actions />
        </>
      )}
      <ModalCommon open={open} setOpen={setOpen} content={<ModalContent />}>
      {tab === 0 && (
 <Box display="flex" flexDirection="column" pb={10} gap={3}>
 <Box textAlign="center">
   <Typography variant="h4" textTransform="uppercase">
     Tờ khai thuế thu nhập doanh nghiệp (Mẫu số 02/TNDN)
   </Typography>
   <Typography variant="subtitle1" fontStyle="italic" fontSize={14}>
     (Áp dụng đối với hoạt động chuyển nhượng bất động sản theo từng lần phát sinh)
   </Typography>
 </Box>
 <Formik initialValues={initialValues} validationSchema={validation} onSubmit={handleSubmit}>
   {({ values, errors, touched, isSubmitting, setFieldValue }) => (
     <Form id={formId} autoComplete="off">
       <Fields
         formData={{
           values,
           touched,
           formField,
           errors,
         }}
       />
       <TaxPersonalTable
         formData={{
           values,
           touched,
           formField,
           errors,
         }}
         setFieldValue={setFieldValue}
       />
       <SoftBox display="flex" justifyContent="flex-end" gap={3}>
         <SoftButton disabled={isSubmitting} type="submit" variant="gradient" color="dark">
           {isSubmitting ? <Loading width={25} height={25} /> : "Gửi"}
         </SoftButton>
       </SoftBox>
     </Form>
   )}
 </Formik>
</Box>
      )}
      </ModalCommon>
    </DashboardLayout>
  );
}

function Fields({ formData }) {
  const { formField, values, errors, touched } = formData;
  const {
    firstTime,
    supplementaryForThe,
    taxAgencyId,
    taxAgencyName,
    taxCalculationPeriod,
    taxId,
    taxpayerName,
    addressWard,
    addressDistrict,
    addressCity,
    address,
    addressEstate,
    addressCityEstate,
    addressDistrictEstate,
    addressWardEstate,
    contract,
    contractDate,
    notarizedDate,
    taxAgentName,
    taxAgentId,
  } = formField;
  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Grid spacing={3} container>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <DatepickerField
            options={{
              dateFormat: "m-YY",
              plugins: [
                new monthSelectPlugin({
                  shorthand: true,
                  dateFormat: "m/Y",
                  theme: "light",
                }),
              ],
            }}
            name={taxCalculationPeriod.name}
            label={taxCalculationPeriod.label}
            error={errors.taxCalculationPeriod && touched.taxCalculationPeriod}
            success={
              values.taxCalculationPeriod?.toString().length > 0 && !errors.taxCalculationPeriod
            }
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <SwitchField name={firstTime.name} label={firstTime.label} value={values.firstTime} />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <FormField
            name={supplementaryForThe.name}
            label={supplementaryForThe.label}
            value={values.supplementaryForThe}
            error={errors.supplementaryForThe && touched.supplementaryForThe}
            success={
              values.supplementaryForThe?.toString().length > 0 && !errors.supplementaryForThe
            }
          />
        </Grid>
        {/* //////////////////////// */}
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <Typography
            fontSize={13}
            marginLeft={0.5}
            fontWeight={"bold"}
            minWidth={210}
            whiteSpace="nowrap"
          >
            1. Bên chuyển nhượng:
          </Typography>
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxpayerName.name}
            label={taxpayerName.label}
            value={values.taxpayerName}
            error={errors.taxpayerName && touched.taxpayerName}
            success={values.taxpayerName?.toString().length > 0 && !errors.taxpayerName}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxId.name}
            label={taxId.label}
            value={values.taxId}
            error={errors.taxId && touched.taxId}
            success={values.taxId?.toString().length > 0 && !errors.taxId}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <Typography
            fontSize={13}
            marginLeft={0.5}
            fontWeight={"bold"}
            minWidth={210}
            whiteSpace="nowrap"
          >
            1. Bên nhận chuyển nhượng:
          </Typography>
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={taxAgencyName.name}
            label={taxAgencyName.label}
            value={values.taxAgencyName}
            error={errors.taxAgencyName && touched.taxAgencyName}
            success={values.taxAgencyName?.toString().length > 0 && !errors.taxAgencyName}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={taxAgencyId.name}
            label={taxAgencyId.label}
            value={values.taxAgencyId}
            error={errors.taxAgencyId && touched.taxAgencyId}
            success={values.taxAgencyId?.toString().length > 0 && !errors.taxAgencyId}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={address.name}
            label={address.label}
            value={values.address}
            error={errors.address && touched.address}
            success={values.address?.toString().length > 0 && !errors.address}
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <FormField
            name={addressWard.name}
            label={addressWard.label}
            value={values.addressWard}
            error={errors.addressWard && touched.addressWard}
            success={values.addressWard?.toString().length > 0 && !errors.addressWard}
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <FormField
            name={addressDistrict.name}
            label={addressDistrict.label}
            value={values.addressDistrict}
            error={errors.addressDistrict && touched.addressDistrict}
            success={values.addressDistrict?.toString().length > 0 && !errors.addressDistrict}
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <FormField
            name={addressCity.name}
            label={addressCity.label}
            value={values.addressCity}
            error={errors.addressCity && touched.addressCity}
            success={values.addressCity?.toString().length > 0 && !errors.addressCity}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <Typography
            fontSize={13}
            marginLeft={0.5}
            fontWeight={"bold"}
            minWidth={210}
            whiteSpace="nowrap"
          >
            [09] Địa chỉ bất động sản được chuyển nhượng:
          </Typography>
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={addressEstate.name}
            label={addressEstate.label}
            value={values.addressEstate}
            error={errors.addressEstate && touched.addressEstate}
            success={values.addressEstate?.toString().length > 0 && !errors.addressEstate}
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <FormField
            name={addressWardEstate.name}
            label={addressWardEstate.label}
            value={values.addressWardEstate}
            error={errors.addressWardEstate && touched.addressWardEstate}
            success={values.addressWardEstate?.toString().length > 0 && !errors.addressWardEstate}
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <FormField
            name={addressDistrictEstate.name}
            label={addressDistrictEstate.label}
            value={values.addressDistrictEstate}
            error={errors.addressDistrictEstate && touched.addressDistrictEstate}
            success={
              values.addressDistrictEstate?.toString().length > 0 && !errors.addressDistrictEstate
            }
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <FormField
            name={addressCityEstate.name}
            label={addressCityEstate.label}
            value={values.addressCityEstate}
            error={errors.addressCityEstate && touched.addressCityEstate}
            success={values.addressCityEstate?.toString().length > 0 && !errors.addressCityEstate}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={contract.name}
            label={contract.label}
            value={values.contract}
            error={errors.contract && touched.contract}
            success={values.contract?.toString().length > 0 && !errors.contract}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <DatepickerField
            options={{
              dateFormat: "m-YY",
              plugins: [
                new monthSelectPlugin({
                  shorthand: true,
                  dateFormat: "m/Y",
                  theme: "light",
                }),
              ],
            }}
            name={contractDate.name}
            label={contractDate.label}
            error={errors.contractDate && touched.contractDate}
            success={values.contractDate?.toString().length > 0 && !errors.contractDate}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <DatepickerField
            options={{
              dateFormat: "m-YY",
              plugins: [
                new monthSelectPlugin({
                  shorthand: true,
                  dateFormat: "m/Y",
                  theme: "light",
                }),
              ],
            }}
            name={notarizedDate.name}
            label={notarizedDate.label}
            error={errors.notarizedDate && touched.notarizedDate}
            success={values.notarizedDate?.toString().length > 0 && !errors.notarizedDate}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxAgentName.name}
            label={taxAgentName.label}
            value={values.taxAgentName}
            error={errors.taxAgentName && touched.taxAgentName}
            success={values.taxAgentName?.toString().length > 0 && !errors.taxAgentName}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxAgentId.name}
            label={taxAgentId.label}
            value={values.taxAgentId}
            error={errors.taxAgentId && touched.taxAgentId}
            success={values.taxAgentId?.toString().length > 0 && !errors.taxAgentId}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
